import $ from 'jquery';
import debounce from 'lodash.debounce';

class Header {
    constructor() {
        $(window).scroll(debounce(this.listenForScrollTop, 40));
    }

    listenForScrollTop = () => {
        const scroll = $(window).scrollTop();
        let $header = $('.header');

        if(scroll !== 0) {
            $header.addClass('header--faded');
        } else {
            $header.removeClass('header--faded');
        }
    }
}

export default Header;



// WEBPACK FOOTER //
// ./components/views/header.js